/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
import serviceCall from '../../../src/store/serviceCall';

const getLandingPage = () => dispatch =>
  serviceCall.getData('Configuration').then(res => {
    if (res) {
      dispatch({ type: 'LANDING_PAGE', response: res.data });
    }
  });

const menuListItem = () => dispatch =>
  serviceCall.getData('Configuration/GetMenuList').then(res => {
    if (res) {
      dispatch({ type: 'MENU_ITEM', response: res.data });
    }
  });

const updateConfiguration = data => dispatch =>
  serviceCall.putData('Configuration', data).then(res => {
    if (res) {
      dispatch({ type: 'UPDATE_CONFIGURATION', response: res });
    }
  });

const updateConfigurationPDFPassword = data => () =>
  serviceCall.postData('configuration/SaveConfigPassword', {
    ConfigurationPassword: (data.ConfigurationPassword || '').trim(),
  });

const getConfiguration = () => dispatch =>
  serviceCall.getData('Configuration/GetLandingPage').then(res => {
    if (res) {
      dispatch({ type: 'USER_LANDING_PAGE', response: res.data });
    }
  });
const storeLoginUrl = value => ({
  type: 'FROM_LOGIN_LOGIN',
  response: value,
});
const makePrevious = value => ({
  type: 'BACK_TO_LOGIN_STATE',
  response: value,
});
export {
  getLandingPage,
  menuListItem,
  updateConfiguration,
  updateConfigurationPDFPassword,
  getConfiguration,
  storeLoginUrl,
  makePrevious,
};
